import Grid from '@blocks/Grid'
import Input from '@blocks/Input'
import List from '@components/modules/List'
import React, { useMemo } from 'react'
import TrackingParticipation from './components/TrackingParticipations'
import TrackingFormContext from './context'

export default function TrackingForm({ model: tracking, salon }: Props) { 
    const participations = salon.api.participations.tracking.use(`admin:salon:${salon.state.id}:participations:tracking`)

    const awards = useMemo(() => {
        const external = participations.data?.map(mapToOption) || []
        const internal = tracking?.participations.map(mapToOption) || []
        return [ ...external, ...internal ]
    }, [participations.data])

    return (
        <TrackingFormContext.Provider value={{ awards }}>
            <Grid gap="20px">
                <Grid gap="20px">
                    <Input required defaultValue={tracking?.number} id="number" name="number" label="Number" placeholder="0000-0000-0000" />
                    <Input defaultValue={tracking?.comment || undefined} id="comment" name="comment" label="Comment" placeholder="Delivery details" />
                </Grid>
                <Grid gap="10px">
                    <b>Awards</b>
                    <List items={tracking?.participations} element={TrackingParticipation} />
                </Grid>
            </Grid>
        </TrackingFormContext.Provider>
    )
}

interface Props {
    model?: Admin.Resources.Tracking
    salon: Admin.Models.Salon.Stateful
}

function mapToOption(participation: Admin.Resources.ParticipationTracking) {
    return ({ 
        value: participation.id.toString(), 
        label: `${participation.user.first_name} ${participation.user.last_name} (${participation.award})` 
    })
}